import * as __WEBPACK_EXTERNAL_MODULE_clsx__ from "clsx";
import * as __WEBPACK_EXTERNAL_MODULE__tailwind_merge_js_c414b9f7__ from "./tailwind-merge.js";
function cn(...inputs) {
    return (0, __WEBPACK_EXTERNAL_MODULE__tailwind_merge_js_c414b9f7__.twMerge)((0, __WEBPACK_EXTERNAL_MODULE_clsx__.clsx)(inputs));
}
export { cn };
